import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import $ from "jquery";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class PrivilegeEventRegister extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            jwt: jwt,
            user_permission: user_permission,
            miss_su: helpers.getUserType(user_type, "su"),
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            userid: user_id,
            pages: [],
            page: 0,
            rowsPerPage: 10,
            add_id: "",
            add_member_name: "",
            add_member_email: "",
            add_member_phone: "",
            add_topic: "",
            add_detail: "",
            srcIsOpen: false,
            project_home: [],
            src_member_name: '',
            src_member_phone: '',
            src_member_email: '',
            src_topic: '',
            src_detail: '',
            val_project: "",
            residenceAll: [{ value: '', display: 'เลือกบ้านเลขที่' }],
            add_residenceAll: "",
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.openView = this.openView.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.change = this.change.bind(this);
        this.changeProject = this.changeProject.bind(this);

        this.project_home()
        this.dataTable();
    }

    project_home() {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    })
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    })
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    residenceAll() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/residencesSrc', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = data.data.map(data => {
                        return { value: data.id, display: `${data.house_no}(${data.project_name})` }
                    });
                    this.setState({
                        residenceAll: [{ value: '', display: 'เลือกบ้านเลขที่' }].concat(FromApi)
                    });
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            }
    
            if (this.state.PROJECTID && this.state.val_project == '') {
                this.state.val_project = this.state.PROJECTID
            }
    
            fetch(config.url.API_URL + '/event_register?projecthomeid=' + this.state.val_project
                + '&name=' + this.state.src_member_name
                + '&email=' + this.state.src_member_email
                + '&residenceid=' + this.state.add_residenceAll
                + '&phone=' + this.state.src_member_phone, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var DataFrom = data.data
                    
                    this.setState({
                        pages: [].concat(DataFrom)
                    });
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/event_register/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataSub => {
                    var data = dataSub.data[0];
                    
                    this.setState({
                        add_id: data._id,
                        add_member_name: `${data.first_name} ${data.last_name}`,
                        add_member_phone: data.phone,
                        add_topic: data.topic,
                        add_detail: data.events[0].title,
                        add_project: data.project_homes[0].name_th,
                        add_houseno: data.residences[0].house_no,
                        add_start_date: moment(data.events[0].start_date).format("DD/MM/YYYY"),
                        add_end_date: moment(data.events[0].end_date).format("DD/MM/YYYY")
                    });
                    console.log(data.project_name)
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeAdd() {
        this.setState({
            addIsOpen: false
        });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_member_name: '',
            src_member_phone: '',
            src_member_email: '',
            val_project: "",
            src_topic: '',
            src_detail: '',
            add_residenceAll: '',
            residenceAll: [{ value: '', display: 'เลือกบ้านเลขที่' }],
            page: 0
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    changeProject(e) {
        try {
            this.setState({
                [e.target.name]: e.target.value
            });
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/residences/?projecthomeid=' + e.target.value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let FromApi = data.data.map(datas => {
                        return { value: datas.id, display: datas.house_no }
                    });
    
                    this.setState({
                        residenceAll: [{ value: '', display: 'เลือกบ้านเลขที่' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page 
        }
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Event Register List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Event register</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="privilegeeventregister" element={(
                                        this.state.user_permission[235].permission == 1 && <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="privilegeeventregister">
                                            <ExcelColumn label="กิจกรรม" value={(col) => col.events[0].title} />
                                            <ExcelColumn label="โครงการ" value={(col) => col.project_homes[0].name_th} />
                                            <ExcelColumn label="บ้านเลขที่" value={(col) => col.residences.length > 0 ? col.residences[0].house_no : ""} />
                                            <ExcelColumn label="ชื่อ" value={(col) => `${col.first_name} ${col.last_name}`} />
                                            <ExcelColumn label="วันที่สร้าง" value={(col) => moment(col.created).format("DD/MM/YYYY H:mm น.")} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '80px' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: '400px' }}>กิจกรรม</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>ชื่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>การจัดการ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.events[0].title}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_homes.length > 0 ? data.project_homes[0].name_th : ""}</StyledTableCell>
                                                                    <StyledTableCell>{data.residences.length > 0 ? data.residences[0].house_no : ""}</StyledTableCell>
                                                                    <StyledTableCell>{`${data.first_name} ${data.last_name}`}</StyledTableCell>
                                                                    <StyledTableCell>{moment(data.created).format("DD/MM/YYYY H:mm น.")}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>ตรวจสอบข้อมูล</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อผู้ใช้</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_member_name}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทร</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_member_phone}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_project}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บ้านเลขที่</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_houseno}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">กิจกรรม</div>
                                <div className="col-sm-5">
                                    <TextareaAutosize className="form-control" aria-label="minimum height" name="add_detail" rowsMin={1} defaultValue={this.state.add_detail} disabled />
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่เริ่มกิจกรรม</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_start_date}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่สิ้นสุดกิจกรรม</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_end_date}</div>
                                </div>
                            </div> */}
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อผู้ใช้</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_member_name" name="src_member_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทร</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_member_phone" name="src_member_phone" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.changeProject}>
                                        {this.state.project_home.map((datas) =>
                                            <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" > บ้านเลขที่ :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_residenceAll" onChange={this.change}>
                                        {this.state.residenceAll.map((data, i) => <option key={i} value={data.value}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div><button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button></div>
                        <div><button className="btn btn-success" onClick={this.submitSrc}>ตกลง</button></div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}